import a from "./ghl-ui.es1379.js";
import t from "./ghl-ui.es793.js";
import e from "./ghl-ui.es684.js";
function o() {
  this.size = 0, this.__data__ = {
    hash: new a(),
    map: new (e || t)(),
    string: new a()
  };
}
export {
  o as default
};
